import React from "react";
import UserDropdown from "./DashboardUserDropdown";
import DoughnutChart from "./payoutOverviewChart";
import LinkSection from "./UserLinks";
import { useSelector } from "react-redux";
import { ApiHook } from "../../hooks/apiHook";

const RightContentSection = ({ props }) => {
  console.log("props in right content", props);

  const currency = useSelector(state => state.user?.selectedCurrency);
  const conversionFactor = useSelector((state) => state.user?.conversionFactor);
  const userSelectedLanguage = useSelector(
    (state) => state.user?.selectedLanguage
  );
  const LmsSite = ApiHook.CallLmsApiSite()
  return (
    <>
      <UserDropdown props={props?.userProfile} LmsSite={LmsSite?.data} />
      <DoughnutChart
        pending={props?.payoutDoughnut?.pending}
        approved={props?.payoutDoughnut?.approved}
        paid={props?.payoutDoughnut?.paid}
        payoutPaid={props?.payoutOverview?.payoutPaid}
        currency={currency}
        conversionFactor={conversionFactor}
        userSelectedLanguage={userSelectedLanguage}
      />
      {
        props?.userProfile &&
        <LinkSection
          payoutTab={props?.payoutOverview}
          replicaLink={props?.replicaLink}
          leadCaptureLink={props?.leadCaptureLink}
          ecomRefLink={props?.ecomRefLink}
          currency={currency}
          conversionFactor={conversionFactor}
          userDetails={props?.userProfile}
        />
      }

    </>
  );
};

export default RightContentSection;
